import { useEffect, useRef, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import { catchFunction } from "../../../../shared/lib/utils";
import SearchInput from "../../../../shared/components/input/SearchInput";
import OverviewComponent from "../../../../shared/components/overview-panel/OverviewComponent";
import OverviewTabContent from "../../../../shared/components/overview-panel/OverviewTabContent";
import DataExplorersOverviewTable from "./DataExplorersOverviewTable";
import { SECTIONS as API_SECTIONS } from "../../../../shared/lib/apiEndpointsResolver";
import { useTracking } from "react-tracking";
import useSectionSorting from "../shared/useSectionSorting";
import { useTranslation } from "react-i18next";

const DataExplorersOverview = () => {
  const axios = useAxios();
  const [dataExplorers, setDataExplorers] = useState([]);
  const dataExplorersRef = useRef([]);
  const { trackEvent } = useTracking();
  const sectionSorting = useSectionSorting();
  const { t } = useTranslation();

  const breadcrumbItems = [
    { title: "dataExplorers.overview.breadcrumb.first" },
  ];

  const findDataExplorers = () => {
    axios
      .get(API_SECTIONS, { params: { category: "data-explorers" } })
      .then((response) => {
        const sortedData = response.data.sort(sectionSorting);
        setDataExplorers(sortedData);
        dataExplorersRef.current = sortedData;
      })
      .catch(catchFunction);
  };

  const filterDataExplorersByTitle = (changeEvent) => {
    setDataExplorers(
      dataExplorersRef.current.filter((de) =>
        t(de.title)
          .toLowerCase()
          .includes(changeEvent.target.value.toLowerCase()),
      ),
    );
  };

  const SearchInputComponent = (
    <SearchInput
      onChangeHandler={filterDataExplorersByTitle}
      placeholder="dataExplorers.overview.searchInputPlaceholder"
    />
  );

  const dataExplorersTabs = [
    {
      trigger: {
        value: "all",
        label: "dataExplorers.overview.tabs.trigger.all",
      },
      content: (
        <OverviewTabContent
          value="all"
          title="dataExplorers.overview.card.all.title"
          description="dataExplorers.overview.card.all.description"
        >
          <DataExplorersOverviewTable data={dataExplorers} />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "adq",
        label: "dataExplorers.overview.tabs.trigger.adq",
      },
      content: (
        <OverviewTabContent
          value="adq"
          title="dataExplorers.overview.card.adq.title"
          description="dataExplorers.overview.card.adq.description"
        >
          <DataExplorersOverviewTable
            data={dataExplorers.filter((x) => x.type.code === "adq")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "powerbi",
        label: "dataExplorers.overview.tabs.trigger.powerbi",
      },
      content: (
        <OverviewTabContent
          value="powerbi"
          title="dataExplorers.overview.card.powerbi.title"
          description="dataExplorers.overview.card.powerbi.description"
        >
          <DataExplorersOverviewTable
            data={dataExplorers.filter((x) => x.type.code === "powerbi")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "gdrive",
        label: "dataExplorers.overview.tabs.trigger.gdrive",
      },
      content: (
        <OverviewTabContent
          value="gdrive"
          title="dataExplorers.overview.card.gdrive.title"
          description="dataExplorers.overview.card.gdrive.description"
        >
          <DataExplorersOverviewTable
            data={dataExplorers.filter((x) => x.type.code === "gdrive")}
          />
        </OverviewTabContent>
      ),
    },
    {
      trigger: {
        value: "lstudio",
        label: "dataExplorers.overview.tabs.trigger.lstudio",
      },
      content: (
        <OverviewTabContent
          value="lstudio"
          title="dataExplorers.overview.card.lstudio.title"
          description="dataExplorers.overview.card.lstudio.description"
        >
          <DataExplorersOverviewTable
            data={dataExplorers.filter((x) => x.type.code === "lstudio")}
          />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findDataExplorers();
    trackEvent({
      page: "data-explorers-overview",
      event: "page-load",
    });
  }, []);

  return (
    <OverviewComponent
      breadcrumbItems={breadcrumbItems}
      options={SearchInputComponent}
      tabs={dataExplorersTabs}
    >
      <OverviewTabContent
        value="all"
        title="dataExplorers.overview.card.title"
        description="dataExplorers.overview.card.description"
      >
        <DataExplorersOverviewTable data={dataExplorers} />
      </OverviewTabContent>
    </OverviewComponent>
  );
};

export default DataExplorersOverview;
